import React, { useState } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const GallerySection = ({ images }) => {
    const [selectedImage, setSelectedImage] = useState(0);

    const handlePrevious = () => {
        setSelectedImage((prev) => (prev === 0 ? images?.length - 1 : prev - 1));
    };

    const handleNext = () => {
        setSelectedImage((prev) => (prev === images?.length - 1 ? 0 : prev + 1));
    };

    return (
        <div className="space-y-4">
            <div className="relative aspect-[16/9] rounded-xl overflow-hidden bg-muted">
                <Image
                    src={images?.[selectedImage]?.url}
                    alt={images?.[selectedImage]?.alt}
                    className="w-full h-full object-cover"
                />

                <button
                    onClick={handlePrevious}
                    className="absolute left-2 md:left-4 top-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-background/80 backdrop-blur-sm hover:bg-background transition-all"
                    aria-label="Previous image"
                >
                    <Icon name="ChevronLeft" size={20} />
                </button>

                <button
                    onClick={handleNext}
                    className="absolute right-2 md:right-4 top-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-background/80 backdrop-blur-sm hover:bg-background transition-all"
                    aria-label="Next image"
                >
                    <Icon name="ChevronRight" size={20} />
                </button>

                <div className="absolute bottom-2 md:bottom-4 left-1/2 -translate-x-1/2 px-3 py-1.5 rounded-full bg-background/80 backdrop-blur-sm">
                    <span className="text-xs font-data font-medium">
                        {selectedImage + 1} / {images?.length}
                    </span>
                </div>
            </div>
            <div className="flex gap-2 overflow-x-auto scrollbar-hide">
                {images?.map((img, index) => (
                    <button
                        key={index}
                        onClick={() => setSelectedImage(index)}
                        className={`relative w-20 h-20 md:w-24 md:h-24 rounded-lg overflow-hidden flex-shrink-0 transition-all ${selectedImage === index
                                ? 'ring-2 ring-primary ring-offset-2' : 'opacity-60 hover:opacity-100'
                            }`}
                    >
                        <Image
                            src={img?.url}
                            alt={img?.alt}
                            className="w-full h-full object-cover"
                        />
                    </button>
                ))}
            </div>
        </div>
    );
};

export default GallerySection;